import {
  TextInput,
  Textarea,
  SimpleGrid,
  Group,
  Title,
  Text,
  Button,
  Container,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { notifications } from "@mantine/notifications";
import "./styles.scss";
import axios from "axios";
import { useState } from "react";
import { useDebouncedCallback } from "use-debounce";

export function ContactComponent() {
  const [loading, setLoading] = useState(false);

  const form = useForm({
    initialValues: {
      name: "",
      email: "",
      subject: "",
      message: "",
    },
    validate: {
      name: (value) => (value.length < 2 ? "Navn må være minst 2 tegn" : null),
      email: (value) =>
        /^\S+@\S+\.\S+$/.test(value) ? null : "Ugyldig e-postadresse",
      subject: (value) => (!value ? "Vennligst fyll ut emne" : null),
      message: (value) =>
        value.length < 10 ? "Meldingen må være minst 10 tegn" : null,
    },
  });

  async function handleSubmit(values) {
    setLoading(true);
    try {
      await axios.post(`/.netlify/functions/sendEmail`, values);

      form.reset();

      notifications.show({
        title: "Suksess!",
        message: "Meldingen din har blitt sendt",
        color: "green",
      });
    } catch (error) {
      notifications.show({
        title: "Feil",
        message: "Kunne ikke sende melding. Ta kontakt via Instagram i stedet.",
        color: "red",
      });
    } finally {
      setLoading(false);
    }
  }

  const debouncedSubmit = useDebouncedCallback(handleSubmit, 1000);

  return (
    <section className="section-pad">
    <Container size="md">
      <form onSubmit={form.onSubmit(debouncedSubmit)}>
        <Title order={2} size="h1" fw={900} ta="center">
          Klar for å ta første steg?
        </Title>
        <Text c="dimmed" ta="center" mt="sm" maw={520} mx="auto">
          Send meg noen ord om hvor du står og hva du vil oppnå, så tar jeg
          kontakt for en uforpliktende prat. Ingen forpliktelser — bare en god
          start.
        </Text>

        <SimpleGrid cols={{ base: 1, sm: 2 }} mt="xl">
          <TextInput
            label="Navn"
            placeholder="Ola Nordmann"
            name="name"
            variant="filled"
            size="md"
            autoComplete="name"
            {...form.getInputProps("name")}
          />
          <TextInput
            label="E-post"
            placeholder="olanordmann@hotmail.com"
            name="email"
            type="email"
            inputMode="email"
            variant="filled"
            size="md"
            autoComplete="email"
            {...form.getInputProps("email")}
          />
        </SimpleGrid>

        <TextInput
          label="Hva gjelder det?"
          placeholder="Vektnedgang, økt energinivå osv..."
          mt="md"
          name="subject"
          variant="filled"
          size="md"
          {...form.getInputProps("subject")}
        />
        <Textarea
          mt="md"
          label="Melding"
          placeholder="Hva lurer du på?"
          maxRows={10}
          minRows={5}
          autosize
          name="message"
          variant="filled"
          size="md"
          {...form.getInputProps("message")}
        />

        <Group justify="center" mt="xl">
          <Button type="submit" size="md" loading={loading}>
            Send melding
          </Button>
        </Group>
      </form>
    </Container>
  </section>
);
}
